'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../tslib.es6-CZ43up4V.js');
const react = require('@emotion/react');
const designSystem = require('@zapier/design-system');
const Label_LabelRequiredText = require('./LabelRequiredText.cjs.js');
const reactAriaComponents = require('react-aria-components');

const LabelStyles = react.css(Object.assign(Object.assign({ display: "flex", flexDirection: "row", gap: `var(--zds-space-2, 4px)`, color: `var(--zds-text-default, ${designSystem.Colors.GrayWarm9})` }, designSystem.Typography.SmallPrint3), { '&[data-compact="true"]': Object.assign({}, designSystem.Typography.MinimalPrint3), "&[data-state=disabled]": {
  color: `var(--zds-text-weakest, ${designSystem.Colors.GrayWarm5})`,
  cursor: "not-allowed"
}, "&[data-state=invalid]": {
  color: `var(--zds-status-error-stronger, ${designSystem.Colors.StatusErrorStronger})`
} }));
const AsteriskStyles = react.css(Object.assign(Object.assign({}, designSystem.Typography.Body2Multiline), { color: `var(--zds-ui-brand, ${designSystem.Colors.GrayWarm9})`, textDecoration: "none" }));
const Label = (_a) => {
  var { children, isCompact, isDisabled, isInvalid, isRequired, requiredText = "required" } = _a, props = tslib_es6.__rest(_a, ["children", "isCompact", "isDisabled", "isInvalid", "isRequired", "requiredText"]);
  return react.jsx(
    reactAriaComponents.Label,
    Object.assign({}, props, { css: LabelStyles, "data-compact": isCompact, "data-state": [isInvalid && "invalid", isDisabled && "disabled"].filter(Boolean).join(" ") || void 0, "data-zds": true }),
    children,
    isRequired && react.jsx("abbr", { css: AsteriskStyles, title: "required" }, "*"),
    isRequired && requiredText && react.jsx(Label_LabelRequiredText.LabelRequiredText, { isDisabled }, requiredText)
  );
};

exports.Label = Label;
//# sourceMappingURL=Label.cjs.js.map
